import { render, staticRenderFns } from "./MypageContainer.vue?vue&type=template&id=3a795ddc"
import script from "./MypageContainer.ts?vue&type=script&lang=ts&external"
export * from "./MypageContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports